import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Inject, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ZoomMtg } from '@zoomus/websdk';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { environment } from 'src/environments/environment';

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();
ZoomMtg.i18n.load('en-US');
ZoomMtg.setZoomJSLib('https://source.zoom.us/2.8.0/lib', '/av');



@Component({
  selector: 'app-join-meeting',
  templateUrl: './join-meeting.component.html',
  styleUrls: ['./join-meeting.component.scss']
})
export class JoinMeetingComponent implements OnInit, AfterViewInit {
  meetingNumber: any;
  sdkKey: string;
  role = 1;
  leaveUrl: string;
  userName: string;
  userEmail: string;
  passWord = '12345678';
  zoomCurrentUser: any;
  ZoomMtgs: any;
  constructor(private service: PagesService, private activatedRoute: ActivatedRoute, private router: Router, private storageService: LocalStorageProvider, private loader: NgxUiLoaderService, private toastr: ToastrService, private ngZone: NgZone) {
    this.leaveUrl = window.location.origin + '/#/coaching/meeting-list';
    const currentUser = this.storageService.getItem('CurrentUser')
    this.userName = currentUser?.firstName + ' ' + currentUser?.lastName;
    this.userEmail = currentUser?.email;
    this.sdkKey = `${environment.meetingConfig.CLIENT_ID}`;
    ZoomMtg.setZoomJSLib(null, null);
    ZoomMtg.prepareWebSDK = null;
  }




  async ngOnInit(): Promise<any> {

  }

  async ngAfterViewInit() {
    const { ZoomMtg } = await import('@zoom/meetingsdk');
    this.ZoomMtgs = ZoomMtg;
    this.ZoomMtgs.setZoomJSLib('https://source.zoom.us/3.8.5/lib', '/av');
    this.ZoomMtgs.preLoadWasm();
    this.ZoomMtgs.prepareWebSDK();
    this.ZoomMtgs.i18n.load('en-US');
    this.getParams();
  }


  getParams() {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params?.['meetingId']) {
        this.meetingNumber = params?.['meetingId'];
        document.getElementById('zmmtg-root').style.display = 'block'
        this.ngZone.runOutsideAngular(() => {
          this.ZoomMtgs.init({
            isSupportAV: true,
            debug: true,
            showMeetingHeader: true,
            webEndpoint: "zoom.us",
            leaveUrl: this.leaveUrl,
            disablePreview: true,
            patchJsMedia: true,
            success: (success) => {
              console.log(success)
              this.getSignature();
            },
            error: (error) => {
              window.location.reload()
              console.log(error)
            }
          })
        })
      }
      else {
        this.router.navigate([`${RouteConstant.coaching + '/' + RouteConstant.meetingList}`])
      }
    })
    // this.activatedRoute.queryParams.subscribe((params: any) => {
    //   if (params?.['meetingId']) {
    //     this.meetingNumber = params?.['meetingId'];
    //     this.ngZone.runOutsideAngular(() => {
    //       this.client.init({
    //         zoomAppRoot: document.getElementById('meetingSDKElement'),
    //         language: 'en-US',
    //         patchJsMedia: true,
    //         leaveOnPageUnload: true,
    //         customize: {
    //           video: {
    //             isResizable: true,
    //             // viewSizes: {
    //             //   default: {
    //             //     width: 700,
    //             //     height: 800
    //             //   }
    //             // }
    //           }
    //         }
    //       }).then(() => {
    //         this.getSignature();
    //       })
    //     })
    //     // .then(() => {
    //     //     console.log(success)
    //     //     this.getSignature();
    //     //   },
    //     //   error: (error) => {
    //     //     window.location.reload()
    //     //     console.log(error)
    //     //   }
    //     // }))

    //   }
    //   else {
    //     this.router.navigate([`${RouteConstant.coaching + '/' + RouteConstant.meetingList}`])
    //   }
    // })
  }


  getSignature() {
    const data = {
      meetingNumber: this.meetingNumber,
      role: this.role
    }
    this.service.get(data, `${API_ROUTES.MEETING.getSignature}`).subscribe({
      next: (response) => {
        if (response.status) {
          this.startMeeting(response.data.signature);
        }
      },
      error: (error) => {
        this.toastr.error(error.msg)
      },
    })

  }

  startMeeting(signature) {
    this.ZoomMtgs.join({
      signature: signature,
      meetingNumber: this.meetingNumber,
      userName: this.userName,
      sdkKey: this.sdkKey,
      userEmail: this.userEmail,
      passWord: this.passWord,
      success: (success) => {
        console.log(success)
        this.ZoomMtgs.getCurrentUser({
          success: (success) => {
            this.zoomCurrentUser = success.result.currentUser
            this.ZoomMtgs.showRecordFunction({
              show: true
            });
          },
          error: (error) => console.log(error)
        })
      },
      error: (error) => {
        // window.location.reload();
        console.log(error)
      }
    })
    // this.client.join({
    //   sdkKey: this.sdkKey,
    //   signature: signature,
    //   meetingNumber: this.meetingNumber,
    //   password: this.passWord,
    //   userName: this.userName,
    //   userEmail: this.userEmail,
    // }).then(() => {
    //   console.log('joined successfully')
    // }).catch((error) => {
    //   console.log(error)
    // })
    // this.client.join({
    //   signature: signature,
    //   meetingNumber: this.meetingNumber,
    //   userName: this.userName,
    //   sdkKey: this.sdkKey,
    //   userEmail: this.userEmail,
    //   password: this.passWord,
    //   success: (success) => {
    //     console.log(success)
    //     ZoomMtg.getCurrentUser({
    //       success: (success) => {
    //         this.zoomCurrentUser = success.result.currentUser
    //       },
    //       error: (error) => console.log(error)
    //     })
    //   },
    //   error: (error) => {
    //     // window.location.reload();
    //     console.log(error)
    //   }
    // })
  }

  ngOnDestroy() {
    document.getElementById('zmmtg-root').style.display = 'none';
    if (this.zoomCurrentUser && this.zoomCurrentUser.isHost) {
      this.ZoomMtgs.leaveMeeting({
        success: (success) => {
          console.log(success)
          window.location.reload();
        },
        error: (error) => {
          window.location.reload();
          console.log(error)
        }
      })
    }
    // 2. Clean up the Zoom SDK root element
    const zoomRoot = document.getElementById('zmmtg-root');
    if (zoomRoot) {
      zoomRoot.style.display = 'none';
    }
    this.zoomCurrentUser = null;
    // this.ZoomMtgs.setZoomJSLib(null, null);
    this.ZoomMtgs.prepareWebSDK = null;
  }
}